// #region imports

// --- Angular
import { Directive, ElementRef } from '@angular/core';

// #endregion

@Directive({
  selector: '[hsFocusable]'
})
export class FocusableDirective {
  constructor(private host: ElementRef) { }

  ngAfterViewInit() {
    this.host.nativeElement.focus();
  }
}
